import type { CustomerProfile } from 'types/auth';

type DiscountProfile = Pick<CustomerProfile, 'porcDesc' | 'porcDesc2' | 'porcDesc3'>;

/** Tramos Desc 1/2/3 mayores a 0, en el orden de la cascada. */
export const customerPercentsOf = (customer: DiscountProfile | null | undefined): number[] => {
  if (!customer) return [];
  return [customer.porcDesc, customer.porcDesc2, customer.porcDesc3]
    .map((value) => {
      const n = Number(value);
      if (!Number.isFinite(n) || n <= 0) return 0;
      return Math.min(n, 100);
    })
    .filter((value) => value > 0);
};

/** Misma cascada que DescuentoCabeceraHelper.AplicarPorcentajesCascada. */
export const applyCustomerCascade = (price: number, percents: readonly number[]): number =>
  percents.reduce((current, percent) => (percent > 0 ? current * (1 - percent / 100) : current), price);
